import type { IconType } from '@deity-io/portal-ui';
import { Button, ButtonGroup, Icon, Menu, MenuItem } from '@deity-io/portal-ui';
import { ListItemIcon, ListItemText } from '@mui/material';
import type { PopoverActionMenuOption } from 'contracts/interfaces/PopoverActionMenuOption';
import type { FC } from 'react';
import React from 'react';

interface ActionPopoverProps {
  options: PopoverActionMenuOption<IconType, string, string>[];
  defaultAction: string;
  defaultActionTitle: string;
  onSelect: (action: string) => void;
}
const ActionPopover: FC<ActionPopoverProps> = ({ options, defaultAction, defaultActionTitle, onSelect }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onOptionSelect = (option: string) => {
    onSelect(option);
    handleClose();
  };

  return (
    <>
      <ButtonGroup variant="outlined">
        <Button variant="outlined" onClick={() => onOptionSelect(defaultAction)}>
          {defaultActionTitle}
        </Button>
        <Button variant="outlined" onClick={handleClick}>
          <Icon icon="arrowDropDown" />
        </Button>
      </ButtonGroup>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose}>
        {options.map(option => (
          <MenuItem onClick={() => onOptionSelect(option.action)} key={option.action}>
            <ListItemIcon>
              <Icon icon={option.icon} />
            </ListItemIcon>
            <ListItemText>{option.text}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ActionPopover;
